<template>
  <div id="app" class="app-root">
    <div v-if="useDesktopFrame" class="desktop-preview-shell">
      <iframe
        class="desktop-preview-frame"
        :src="desktopFrameSrc"
        title="mobile-preview"
      ></iframe>
    </div>

    <div v-else class="app-content">
      <router-view></router-view>
      <Footer />
    </div>
  </div>
</template>

<script>
import Footer from './common/Footer'

export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status: 0,
      isEmbeddedFrame: false,
      useDesktopFrame: false,
      desktopFrameSrc: ''
    };
  },
  methods: {
    getBaseInfo() {
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res => {
        if (!localStorage.getItem('token')) {
          this.$router.push({ path: '/Login' })
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    },
    checkEmbeddedFrame() {
      const params = new URLSearchParams(window.location.search);
      this.isEmbeddedFrame = params.get('mobile_frame') === '1';
    },
    shouldUseDesktopFrame() {
      if (this.isEmbeddedFrame) {
        return false;
      }

      const isWideScreen = window.innerWidth > 430;
      const hasDesktopPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      return isWideScreen && hasDesktopPointer;
    },
    buildDesktopFrameSrc() {
      const url = new URL(window.location.href);
      url.searchParams.set('mobile_frame', '1');
      return url.toString();
    },
    updateDisplayMode() {
      this.checkEmbeddedFrame();
      this.useDesktopFrame = this.shouldUseDesktopFrame();
      if (this.useDesktopFrame) {
        this.desktopFrameSrc = this.buildDesktopFrameSrc();
      }
    },
    handleResize() {
      this.updateDisplayMode();
    }
  },
  created() {
    this.updateDisplayMode();
    if (!this.useDesktopFrame) {
      this.getBaseInfo();
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
}
</script>

<style>
html,
body {
  margin: 0;
  min-height: 100%;
  background: #ffffff;
  overflow-x: hidden;
}

#app,
.app-root,
.app-content {
  min-height: 100vh;
}

.app-content {
  width: 100%;
  background: #ffffff;
}

.desktop-preview-shell {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: stretch;
  background: #000000;
  padding: 0;
}

.desktop-preview-frame {
  width: 35.333vw;
  min-width: 35.333vw;
  height: 100vh;
  border: 0;
  display: block;
  background: #ffffff;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05);
}

body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: auto;
  max-width: calc(100vw - 32px);
  background: linear-gradient(#1d1610, #3b2818) !important;
}

body .van-toast .van-toast__icon {
  font-size: 50px;
}

*,
:after,
:before {
  box-sizing: border-box;
}
</style>
